'use client'

const SelectFilter = ({
  text,
  filters,
  defaultValue,
  setSelected,
  className,
  isSmall,
  value,
  disabledFirstOption = true
}) => {
  return (
    <fieldset>
      <div className="flex">
        <select
          onChange={(e) => {
            setSelected(e.target.value)
          }}
          className={
            isSmall
              ? 'bg-sec-grey-2 border-0 font-alliance-medium rounded-sm text-blue text-[14px] w-full'
              : `${className} bg-sec-grey-4 border-0 font-alliance-medium rounded-sm p-5 text-blue text-[18px] lg:text-[24px] min-w-full lg:min-w-[250px] lg:h-[74px] pr-14`
          }
          defaultValue={defaultValue}
          value={value}
        >
          {text && (
            <option key="0" id="0" value="" disabled={disabledFirstOption}>
              {text}
            </option>
          )}
          {filters?.map((option, idx) => (
            <option
              key={idx}
              id={option.value}
              name={option.value}
              value={option.value}
              defaultValue={option.value === defaultValue}
            >
              {option.title}
            </option>
          ))}
          )
        </select>
      </div>
    </fieldset>
  )
}

export default SelectFilter
